import React from 'react';
import { NavigationRoute, useNavigation, useRouterPath } from 'shared-utils';
import { useYearlyRootNavigation } from 'utils/yearStore';
import Breadcrumb from 'components/Breadcrumb';
import { DashboardNavigation, TrackNavigation } from 'screens/routes';

type Props = {
    label: string;
};

const TrackDetailsBreadcrumb: React.FC<Props> = ({ label }: Props) => {
    const homePath = useRouterPath(DashboardNavigation());
    const [rootNavigations] = React.useState({ trackNav: TrackNavigation });
    const { trackNav } = useYearlyRootNavigation(rootNavigations);
    const trackPath = useRouterPath(trackNav);
    const { push: navigate } = useNavigation();

    const triggerNav = React.useCallback((route: NavigationRoute) => (event: React.MouseEvent<any>) => {
        if (event.ctrlKey || event.metaKey) return;

        event.preventDefault();
        navigate(route);
    }, [navigate]);

    return (
        <Breadcrumb>
            <Breadcrumb.Home
                key="bc-home"
                to={homePath ?? undefined}
                onClick={triggerNav(DashboardNavigation())}
            />
            <Breadcrumb.Item
                key="bc-track"
                to={trackPath ?? undefined}
                onClick={triggerNav(trackNav)}
            >
                Circuits
            </Breadcrumb.Item>
            <Breadcrumb.Item key="bc-track-details">{label}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default TrackDetailsBreadcrumb;
